import {ACTION_CODE} from './_actionCode';
import {ReferenceService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'GET_REFERENCE_BY_ID';

export async function getReferenceById(userData: Record<string, any>, id: number) {
    try {
        LoggerService.logInfo('Action - getReferenceById - Start');

        const getReferenceByIdResult = await ReferenceService.getReferenceById(userData, id);

        LoggerService.logInfo('Action - getReferenceById - End - Success');

        return ResultModel.newSuccessResult(getReferenceByIdResult);
    }
    catch (error: any) {
        LoggerService.logInfo('Action - getReferenceById - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récupération d\'une réference',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
